import React from "react";

class TentPoles extends React.Component {
    render() {
        return (
            <div className="tent-poles container row">
                <style>
                    {`
                .tentpole{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-between;
                    padding: 24px;
                    text-align: center;
                    border-bottom: solid 1px #DADADA;
                    border-right: none;
                }
                .tentpole-img-container{
                    display: flex;
                    justify-content: center;
                    flex-direction: row;
                    align-items: center;
                }
                .tentpole .text{
                    display: flex;
                    flex-direction: column;
                    font-size: 14px;
                    align-items: center;
                }
                .call-to-action{
                    margin: auto;
                    text-align: center;
                }
                @media (min-width: 768px) {
                    .tentpole {
                        border-right: solid 1px #DADADA;
                        border-bottom: none;
                    }
                    .tentpole-3{
                        border: none;
                    }
                    .tentpole .text{
                        font-size: 18px;
                    }
                }
            `}
                </style>
                <div className="tentpole tentpole-1 col-lg-4 col-md-4 col-sm-4 col-xs-12 margin-b-l">
                    <div className="tentpole-img-container">
                        <img
                            src={require("../../img/email/tentpole_ulimitedhand@2x.png")}
                            width="80"
                            height="80"
                            alt="Unlimited royalty–free icons with NounPro"
                        />
                    </div>
                    <div className="text display-flex">
                        <p className="info font-medium weight-medium">
                            Over 1 Million icons,<br /> royalty–free
                        </p>
                        <a
                            className="call-to-action weight-light font-small text-link"
                            href="/pricing/"
                            title="Learn about NounPro"
                        >
                            Learn more
                        </a>
                    </div>
                </div>
                <div className="tentpole tentpole-2 col-lg-4 col-md-4 col-sm-4 col-xs-12  margin-b-l">
                    <div className="tentpole-img-container display-flex margin-t-l">
                        <img
                            src={require("../../img/homepage/app_icons@2x.png")}
                            width="174"
                            height="59"
                            alt="Noun Project apps"
                        />
                    </div>
                    <div className="text display-flex">
                        <p className="info font-medium weight-medium">
                            Get icons in<br />
                            your workflow
                        </p>
                        <span className="call-to-action weight-light font-small">
                            <a
                                className="text-link"
                                href="/apps/"
                                title="Learn more about Noun Project apps"
                            >
                                Check out the apps
                            </a>
                        </span>
                    </div>
                </div>
                <div className="tentpole tentpole-3 col-lg-4 col-md-4 col-sm-4 col-xs-12 margin-b-l">
                    <div className="tentpole-img-container">
                        <img
                            src={require("../../img/pricing/pricing_illustration_change_color@2x.png")}
                            width="60"
                            height="60"
                            alt="pick a color"
                            style={{
                                marginTop: "24px",
                                marginRight: "14px"
                            }}
                        />
                    </div>
                    <div className="text display-flex">
                        <p className="info font-medium weight-medium">
                            Change colors to get<br /> the&nbsp;perfect&nbsp;hue
                        </p>
                        <a
                            className="call-to-action weight-light font-small text-link"
                            href="/preview/color/"
                            title="Try it out"
                        >
                            Try out color
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

module.exports = TentPoles;
